import { initContext } from '@/base/context-init'
import App from './App.vue'

initContext('polkomtel', App)
